export const MS_TRACE_ID = 'x-ms-traceid';
export const TRACEPARENT = 'traceparent';
export const CLIENT_NAME = 'Mns-Graphql-Client-Name';
export const MS_CLIENT_NAME = 'X-MS-Graphql-Client-Name';
export const BAGGAGE = 'baggage';
export const LOCALE_HEADER_NAME = 'x-locale';
